import { render, staticRenderFns } from "./vertical.vue?vue&type=template&id=43aeff79&"
import script from "./vertical.vue?vue&type=script&lang=js&"
export * from "./vertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43aeff79')) {
      api.createRecord('43aeff79', component.options)
    } else {
      api.reload('43aeff79', component.options)
    }
    module.hot.accept("./vertical.vue?vue&type=template&id=43aeff79&", function () {
      api.rerender('43aeff79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/layouts/vertical.vue"
export default component.exports